<template>
  <div class="home">
    <Header :title="spaceInfo.name"></Header>
    <div v-if="hasAuth" class="main" :class="{ 'show-side-bar': showSideBar }">
      <left-side-nav :defaultExpanded="defaultExpanded" :defaultValue="currentID" @openMenu="openMenu"></left-side-nav>
      <div class="page-content">
        <div class="wiki-content" v-html="doc"></div>
      </div>
      <right-side-nav
        v-if="docValue"
        :doc="docValue"
        :title="docTitle"
        :key="currentID"
        :showSideBar="showSideBar"
        @setBarStatus="setBarStatus"
      ></right-side-nav>
    </div>
    <!-- 默认展示该提示语 -->
    <div v-else-if="isLoaded">
      <p class="tips-text">当前账号无访问授权，请联系运营获取权限</p>
    </div>
    <EnvTip></EnvTip>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import Header from '@/components/header';
import EnvTip from '@/components/env-tip';
import LeftSideNav from '@/components/left-side-nav';
import RightSideNav from '@/components/right-side-nav';
import { getLatestCdnUrl, fetchJsonp, checkAuth } from '@/services/index';

export default {
  name: 'home',
  components: {
    Header,
    LeftSideNav,
    RightSideNav,
    EnvTip,
  },
  computed: {
    ...mapState('doc', ['spaceInfo', 'categoryInfo', 'docInfo']),
  },
  data() {
    return {
      defaultExpanded: [],
      title: '',
      doc: '',
      docValue: '',
      currentID: 0,
      docTitle: '',
      showSideBar: true,
      hasAuth: false,
      isLoaded: false,
    };
  },
  created() {
    this.handleAuth();
  },
  watch: {
    '$route.query'() {
      this.loadDocByID(Number(this.$route.query.id));
    },
  },
  methods: {
    ...mapMutations('doc', ['setDocData']),
    async handleAuth() {
      try {
        const res = await checkAuth({
          feature: 'document',
        });
        const { allow = false } = res?.data || {}

        // 有渠道权限或者有超级管理员权限的用户可以查看页面
        if(allow) {
          this.hasAuth = true;
          this.handlePageData();
        }
      } catch (err) {
        console.error('[接口方法:checkAuth]请求失败', err);
        window.location.href = 'https://q.qq.com/channel/manage/?isLoginDialogShow=1';
      }
      this.isLoaded = true;
    },

    /**
     * 处理页面数据
     */
    async handlePageData() {
      let url = ''
      try {
        url = await getLatestCdnUrl();
      } catch (err) {
        console.error('[接口方法:getLatestCdnUrl]请求失败', err);
      }
      if (url) {
        fetchJsonp(url, document);
        window.initWiki = (data) => {
          this.setDocData(data);
          this.init();
        };
      }
    },
    init() {
      let id = Number(this.$route.query.id);
      if (id) {
        this.loadDocByID(id);
      } else {
        id = this.getFirstPageId();
        this.$router.push(`?id=${id}`);
      }
      this.initMenu(id);
    },
    openMenu(item) {
      this.docTitle = item.title;
      if (this.currentID !== item.id) {
        this.$router.push(`?id=${item.id}`);
      }
    },
    async loadDocByID(id) {
      this.currentID = id;
      this.initDocTitle();
      this.docValue = this.docInfo[id]?.html || '暂无内容';
      const html = new DOMParser().parseFromString(this.docValue, 'text/html');
      this.doc = html.body.innerHTML;
      setTimeout(() => {
        Prism.highlightAll();
        // 锚点定位
        document.getElementById(decodeURIComponent(location.hash)?.substring(1))?.scrollIntoView();
      }, 200);
    },
    initDocTitle() {
      const curItem = this.categoryInfo.find((item) => item.id === this.currentID);
      this.docTitle = curItem?.title;
    },
    //菜单只展开当前的
    initMenu(curId) {
      // 遍历把包含childrens的id都找出来
      const getCategoryIDWithChildren = (list, expandedIds) => {
        list.forEach((item) => {
          if (!item.has_children) return;
          if (this.findGenerationsFromId(item.childrens, curId)) {
            expandedIds.push(item.id);
          }
          getCategoryIDWithChildren(item.childrens, expandedIds);
        });
      };
      getCategoryIDWithChildren(this.categoryInfo, this.defaultExpanded);
    },
    // 从子孙后代中查找某个id
    findGenerationsFromId(list, id) {
      const findChildFromId = (list, id) => {
        let result;
        list.some((item) => {
          if (item.id === id) {
            result = item;
          } else if (item.has_children) {
            result = findChildFromId(item.childrens, id);
          }
          return result;
        });
        return result;
      }
      return findChildFromId(list, id);
    },
    setBarStatus(status) {
      this.showSideBar = !!status;
    },
    getFirstPageId() {
      return this.getFirstId(this.categoryInfo[0]);
    },
    getFirstId(item) {
      if (!item.has_children) return item.id;
      return this.getFirstId(item.childrens[0]);
    },
  },
};
</script>

<style scoped>
  .tips-text{
    font-size: 20px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: block;
    text-align: center;
  }
</style>
